<img *ngIf="!!avatar" class="select-none rounded-full" [src]="avatar" />

<div *ngIf="!avatar && alias !== restrictedUserAlias" class="select-none">{{
  initials
}}</div>

<div
  *ngIf="!avatar && alias === restrictedUserAlias"
  class="text-s500 flex select-none flex-row items-center justify-center"
>
  <m-user-icon></m-user-icon>
</div>

<div *ngIf="alias$ | async"></div>
